// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OBNa5QnAxcweyF {
  display: flex;
  position: relative;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  min-height: 32px;
  padding: var(--ds-space-075, 6px) var(--ds-space-075, 6px) var(--ds-space-075, 6px) var(--ds-space-200, 16px);
  transition: background-color ease-in 250ms, padding ease-in 250ms;
  border-bottom: 1px solid var(--ds-border, #091e4224);
  background-color: var(--ds-background-accent-gray-subtlest, #f1f2f4);
  color: var(--ds-text, #172b4d);
  font-weight: var(--ds-font-weight-bold, bold);
  line-height: 22px;
}
.OBNa5QnAxcweyF._bDo_ewr3Eq6oe {
  background: var(--ds-background-warning, #fff7d6);
}
.OBNa5QnAxcweyF.LwPtexXalbM0sQ {
  background: var(--ds-background-information, #e9f2ff);
}
.OBNa5QnAxcweyF.q1pyrN_QjYYjcE {
  background: var(--ds-background-discovery, #f3f0ff);
}
.OBNa5QnAxcweyF.cD0hFW_k6jDV5E {
  background-color: var(--ds-background-neutral-bold, #44546f);
}
.OBNa5QnAxcweyF.cD0hFW_k6jDV5E,
.OBNa5QnAxcweyF.cD0hFW_k6jDV5E * {
  color: var(--ds-text-inverse, #ffffff);
}
.OBNa5QnAxcweyF.rlO3LDvtShV2pc {
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  padding-right: 46px;
}
.OBNa5QnAxcweyF .jAbsZu7bklXeyj {
  position: absolute;
  top: 50%;
  right: var(--ds-space-075, 6px);
  min-width: 34px;
  margin: var(--ds-space-negative-200, -16px) var(--ds-space-0, 0) var(--ds-space-0, 0);
  padding: var(--ds-space-0, 0);
}
.OBNa5QnAxcweyF .jAbsZu7bklXeyj .qLJlS1zpSbzTVC {
  margin-right: var(--ds-space-0, 0);
}
@media print {
  .OBNa5QnAxcweyF {
    display: none;
  }
}
`, ""]);
// Exports
export var headerBanner = `OBNa5QnAxcweyF`;
export var warning = `_bDo_ewr3Eq6oe`;
export var info = `LwPtexXalbM0sQ`;
export var discovery = `q1pyrN_QjYYjcE`;
export var neutralBold = `cD0hFW_k6jDV5E`;
export var hasCloseButton = `rlO3LDvtShV2pc`;
export var closeButton = `jAbsZu7bklXeyj`;
export var closeIcon = `qLJlS1zpSbzTVC`;
export default ___CSS_LOADER_EXPORT___;
